// src/main.ts

import { AppComponent } from "./app/app.component";
import { enableProdMode } from "@angular/core";
import { environment } from "./environments/environment";
import { BUILD_INFO } from "./build-info";

// Build stamp — identifies which build is live (see scripts/gen-build-info.mjs).
console.log(
  `%c[HC build] ${BUILD_INFO.time} · ${BUILD_INFO.sha}${BUILD_INFO.dirty ? ' (dirty)' : ''} · org=${(environment as any).org}`,
  'font-weight:bold;color:#1976d2'
);
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { authInterceptor } from './app/auth.interceptor';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app/app.routes';
import { provideZonelessChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations'; // Still needed for Material
import { provideNativeDateAdapter } from '@angular/material/core';

// AG-GRID
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { ModuleRegistry } from 'ag-grid-community';

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-080558}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Business_Data_Applications_Corp.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Business_Data_Applications_Corp}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Business_Data_Applications_Corp}_need_to_be_licensed___{Business_Data_Applications_Corp}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{29_July_2026}____[v3]_[01]_MTc4NTI3OTYwMDAwMA==d9b0bddd947425fa572111bc128b93be");
ModuleRegistry.registerModules([AllEnterpriseModule]);

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideRouter(routes),
    provideZonelessChangeDetection(), // Angular 20 zoneless change detection
    provideAnimations(), // Deprecated but still needed for Angular Material
    provideNativeDateAdapter(), // Required for Material datepicker - this is the key one!
    providePrimeNG()
  ]
})
.then(() => {
  console.log('%cfinished launching', 'color: #00c853; font-size: 28px; font-weight: bold;');
})
.catch(err => console.log(err));